import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from '@/modules/core/services/table-utils';

const settingsServiceName = "Rest-Service: ";
const REST_EXTERNAL_API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/oauth/external';

export default class RestService {

    static async readAllRestsPaginated(page, size, search, sort, sortAsc, successF, errorF) {
        let params = createPageableParams(page, size, search, sort, sortAsc, successF, errorF, ['name'], ['name']);
        await WrapperService.get(REST_EXTERNAL_API_URL + '/page?' + params, null, settingsServiceName, successF, errorF);
    }

    static async saveRestExternal(rest, successF, errorF) {
        if (typeof rest.id === 'undefined' || rest.id === null) {
            await WrapperService.post(REST_EXTERNAL_API_URL, rest, settingsServiceName, successF, errorF);
        } else {
            await WrapperService.put(REST_EXTERNAL_API_URL + '/' + rest.id, rest, settingsServiceName, successF, errorF);
        }
    }

    static async deleteRest(id, successF, errorF) {
        await WrapperService.delete(REST_EXTERNAL_API_URL + '/' + id, null, settingsServiceName, successF, errorF);
    }
}